import { useQuery } from 'react-query';
import type { PreviewEmailVisibility } from 'services/api/preview/ApiPreviewRepository';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';

type useDocumentPreviewEmailVisibilityParams = {
  documentId: string;
  contentId: string;
  enabled?: boolean;
};

export const DOCUMENT_PREVIEW_PERMISSIONS_QUERY_KEY = (documentId: string) => ['document_preview_permissions', documentId];

export function useGetDocumentPreviewEmailVisibility({ documentId, contentId, enabled = true }: useDocumentPreviewEmailVisibilityParams) {
  const {
    data: previewEmailVisibility,
    isLoading,
    isFetched,
  } = useQuery({
    queryKey: DOCUMENT_PREVIEW_PERMISSIONS_QUERY_KEY(documentId),
    queryFn: (): Promise<PreviewEmailVisibility> =>
      apiDocumentServiceRepository.getDocumentData({ contentId }).then((response) => ({
        has_email_visibility: response.hasEmailVisibility ?? false,
      })),
    enabled,
  });

  return {
    previewEmailVisibility,
    isLoading,
    isFetched,
  };
}
